import SideMenu from "../sideMenu";
import { useLocation } from "react-router-dom";
import DashboardHeader from "../topbar";
import { makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { useEffect , useState } from 'react'
import {  getPositionsDetails } from "../positions/services";
import { getAppliedCandidate } from './services'
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import AppliedCandidates from './appliedCandidates'
import { viewedpageMixpanel } from "../../utils/mixpanel";


function PositionDetails() {

    const menu = makeSideBarActive(CONSTANTS.sideMenu, 0);
    const [companyPositionName , setCompanyPositioName] = useState<string>()
    const [jobsId , setJobsId] = useState<any>()
    const location = useLocation();
    const { jobId }: any = location.state || ''
    const { positionName }: any = location?.state || ''
    const { companyName } :any = location.state || ''
    const providerId = localStorage.getItem('customerId')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
    const [appliedResources, setAppliedResources] = useState([])
    const [jobStatus, setJobStatus] = useState<number>()
    const [jobMetadata, setJobMetadata] = useState<{
        resourceCount: number , experienceRange: number , contractDuration : string , contractStartDate: number , minimumBudget: number , maximumBudget: number ,
        billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}],
        closedCount: number , jobDescription : string, priority: number, lossCount: number , supportingDocument: string
    }>({
        resourceCount: 0, experienceRange: 0 , contractDuration: "" , contractStartDate: 0 , minimumBudget: 0 , maximumBudget: 0 ,
        billingType: "",jobRole: {id: 0, name: ""} , coreSkills: [{skillId: 0, skillName: ""}] , otherSkills: [{skillId: 0, skillName: ""}],
        closedCount: 0, jobDescription: "", priority: 5, lossCount:0 , supportingDocument: "" 
    })

    useEffect(() => {
        setCompanyPositioName(positionName)
        setJobsId(jobId)
        getPositionDetails(jobId)
        getAppliedCandidates(jobId, providerId)
        viewedpageMixpanel()

    }, [jobId, positionName, providerId]);

    let BreadcrumsValues = ['Positions', companyPositionName ]

    const getPositionDetails = (jobId: string) => {
        getPositionsDetails(jobId).then((response) => {  
            if (response && response.status === 1) {          
                setJobMetadata(response.data[0].job_metadata)
                setJobStatus(response.data[0].job_status)            
            }
        })
    }

    const getAppliedCandidates = (jobId: string , providerId: any) => {
        getAppliedCandidate(jobId , providerId).then((resp) => {
            if( resp && resp.status === 1 ){
            setAppliedResources(resp.data)
            }
        }) 
    }

    const convert = (item:any) => {
        if(item){
            const contentState = editorState.getCurrentContent();
            if(JSON.stringify(convertToRaw(contentState)) !== item) {
                try{
                    let abd = draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(item))).getCurrentContent()))
                    let strippedHtml = abd.replace(/<[^>]+>/g, '');
                    return strippedHtml
                }
                catch (e) {
                    return item
                }
            }
        }
    }
  
    return (
        <section className="dashboardWrapper">
            <SideMenu menu={menu}/>
            <div className="dashboardContent">
                <DashboardHeader
                    title={BreadcrumsValues}
                    searchChange={undefined}
                    jobId={jobsId}
                    companyName={companyName}
                    jobStatus={jobStatus}
                />
                < AppliedCandidates jobStatus={jobStatus} jobMetadata={jobMetadata} convert={convert} appliedResources={appliedResources} jobId={jobsId} companyName={companyName} getAppliedCandidates={() => getAppliedCandidates(jobsId , providerId)}/>
            </div>
        </section>
    )
}
export default PositionDetails;